<template>
  <div class="container">
    <panel
      Title=" وضعیت کاربران "
      Des="از طریق این فرم میتوانید مدیریت کاربران شعبه خود را انجام دهید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <loading v-if="loadingRender"></loading>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-md-8 col-12">
        <net-pa-card>
          <template v-slot:header>
            <h6><i class="fas fa-users"></i> جستوجوی کاربران</h6>
          </template>
          <template v-slot:content>
            <div class="container">
              <div class="row mb-5">
                <div class="col-md-1 m-1">
                  <label for="CodeMeli">کدملی کاربر</label>
                </div>
                <div class="col-md-6 col-12 my-1 m-1">
                  <form id="searchAza">
                    <input
                      type="text"
                      @keypress="$ValidNumber($event, 14)"
                      id="CodeMeli"
                      class="form-control text-left required-CodeMeli"
                      v-model="CodeMeli"
                      autocomplete="off"
                    />
                  </form>
                </div>

                <div class="col-md-3 col-12 m-1">
                  <button
                    class="btn btn-success w-100"
                    @click="SearchByCodeMeli"
                  >
                    جستوجوی مشتری
                  </button>
                </div>
              </div>
              <div
                v-if="searchedUSer != null"
                class="row mt-5 px-3 pulse"
                id="animate"
              >
                <div class="col-md-6 col-12 my-1">
                  <div class="row">
                    <div class="col-4">
                      <small>مشخصات کاربر</small>
                    </div>
                    <div class="col-8 text-right">
                      {{ Moshakhasat }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12 my-1">
                  <div class="row">
                    <div class="col-4">
                      <small>شماره مشتری </small>
                    </div>
                    <div class="col-8 text-right">
                      {{ ShomareOzv }}
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-12"></div>
                <div class="col-7 mx-2"></div>
                <div class="col-12 col-md-3 mt-3 mx-2">
                  <button class="w-100 btn btn-info" @click="UserLogin()">
                    ورود به پنل کاربر
                  </button>
                </div>
                <div class="col-1"></div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  data() {
    return {
      CodeMeli: "",
      Moshakhasat: "",
      ShomareOzv: "",
      searchedUSer: null,
      dataLogin: null,
      infoNetPa: null,
      isLogin: false,
      loadingRender: false,
    };
  },
  components: { NetPaCard, Panel, loading },
  methods: {
    SearchByCodeMeli() {
      if (this.$requiredCodeMeli("searchAza")) {
        this.loadingRender = true;
        var formdata = new FormData();
        formdata.append("Codemeli", this.CodeMeli);
        formdata.append(
          "tafslyid",
          this.$session.get("UserInfoNetPa").wwwtblTafsiliTypeId,
        );
        var DataAxiosGetuser = {
          ArryfildValue: formdata,
          Method: "Post",
          Action: "ManageUserCodeMeli",
          Token: this.$session.get("TokenNetPa"),
        };

        this.$PostFormData(DataAxiosGetuser).then((data) => {
          if (data.status == "OK") {
            this.loadingRender = false;
            this.searchedUSer = data.data.id;
            this.dataLogin = data.data;
            this.$mySweetDefaultTost("عملیات موفق", "", "success", 2000);
            this.Moshakhasat = data.data.ozvName + " " + data.data.ozvFamily;
            this.ShomareOzv = data.data.shomareOzv;
          } else {
            this.loadingRender = false;
            this.searchedUSer = null;
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              " کاربری بااین اطلاعات پیدا نشد.   ",
              "error",
              4000,
            );
          }
        });
      }
    },
    UserLogin() {
      if (this.searchedUSer != null) {
        if (
          this.$store.state.Netpa_Cart &&
          this.$store.state.Netpa_Cart.length > 0
        ) {
          this.$SweetQustion(
            " سبد اقساط  ",
            " مدیریت شعبه : با توجه  به اینکه  سبد اقساط شما داری تعدادی قسط می باشد در صورت ورود به  پورتال کاربری فرد دیگر سبد شما خالی خواهد شد ",
            "question",
            "تایید و ادامه",
            "انصراف",
            null,
            () => {
              this.$store.state.Netpa_Cart = [];
              this.loginModirShobe();
            },
            () => {},
          );
        } else {
          this.loginModirShobe();
        }
      } else {
        this.searchedUSer = null;
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "امکان ورود به پنل کاربر وجود ندارد لطفا مجددا تلاش کنید",
          "error",
          2000,
        );
      }
    },
    loginModirShobe() {
      this.$session.set(
        "UserInfoNetPaModirShobe",
        this.$session.get("UserInfoNetPa"),
      );
      this.loadingRender = true;
      var DataAxiosModirShobe_Login = {
        ArryfildValue: "",
        Method: "POST",
        Action: "NetPaLoginModirShobe",
        Token: "",
      };

      var formdata = new FormData();
      formdata.append("UserName", this.dataLogin.codeMeli);
      formdata.append("Pass", this.$Encryption(this.dataLogin.webPss));
      DataAxiosModirShobe_Login.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosModirShobe_Login)
        .then((resNetpa) => {
          if (resNetpa == null) {
            this.$mySweetDefaultTost(
              "خطای رمز ! عملیات ناموفق",
              "خطا در ورود به پنل کاربر لطفا با راهبر سیستم تماس بگیرید. ",
              "error",
              5000,
            );
            return;
          }
          if (resNetpa.id != null) {
            this.infoNetPa = resNetpa;
            this.$session.start();
            this.$session.set("TokenNetPa", this.infoNetPa.token);
            this.$session.set("UserInfoNetPa", this.infoNetPa);
            this.isLogin = true;
          }
        })
        .finally(() => {
          if (this.isLogin) {
            this.$router.push("/PishkhanNetPa/Home");
          }
          this.loadingRender = false;
          // window.location.reload() ;
        });
    },
  },
};
</script>
<style scoped>
.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>
